export default __webpack_public_path__ + "static/media/verified-code.fac6edfd.svg";